export const CONTAINER_STYLES = {
  main: "relative flex flex-col items-center overflow-hidden w-full max-w-[440px] mx-[auto] my-0 border-box min-h-[100vh] bg-cover bg-center",
  formWrapper: "w-full text-[#666666] flex flex-col mt-16 px-[45px] max-xs:px-[20px]",
  inputContainer: "flex text-[#666666] p-3 rounded-lg",
  button: "bg-[#860830] text-white border-0 rounded-[7px] m-auto",
  textCenter: "text-center bg-transparent",
  iconMargin: "mr-5",
};
